import Topo from "../../../Componentes/TopCategorias"
import ArrowRight from "../../../Assets/svg/arrowRight.svg"
import { useHistory } from "react-router-dom"
import { useEffect, useState } from "react"
import requestBanners from "../../../Services/api/banners"
import { CircularProgress } from "@material-ui/core"
import { useStyles } from "../style"
import CustomAlert from "../../../Componentes/Alerts/CustomAlert"

const initialBanners = [
    { banner_position: "1" },
    { banner_position: "2" },
    { banner_position: "3" },
    { banner_position: "4" },
    { banner_position: "5" },
    { banner_position: "6" },
    { banner_position: "7" },
    { banner_position: "8" },
]

export default function Banner() {
    const history = useHistory()
    const [banners, setBanners] = useState(initialBanners)
    const [isLoading, setIsLoading] = useState(true)
    const [alertType, setAlertType] = useState("")
    const [showAlertOk, setShowAlertOk] = useState(false)
    const [showAlertError, setShowAlertError] = useState(false)
    const classes = useStyles()

    const getBanners = async () => {
        try {
            const { data } = await requestBanners.getPrimaryBanners()
            const receivedBanners = data.data
            setBanners(currentBanners =>
                currentBanners.map(banner =>
                    receivedBanners.find(receivedBanner => receivedBanner.banner_position == banner.banner_position) || banner
                ))
            setIsLoading(false)
        } catch (e) {
            setAlertType("error")
            setShowAlertOk(true)
        }
    }

    const closeAlerts = () => {
        setShowAlertOk(false)
        setShowAlertError(false)
    }

    useEffect(() => {
        getBanners()
    }, [])

    return (
        <>
            <div className="page-container">
                <div className="page-align" style={{ justifyContent: "flex-start" }}>
                    <div>
                        <Topo rota={"/personalizar-lojinha"} name="Banners principais" />
                    </div>
                    <div className="infinite-scroll">
                        {isLoading ? (
                            <div
                                style={{
                                    backgroundColor: " #fff",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    width: "100%",
                                    height: "100%"
                                }}
                            >
                                <CircularProgress color="secondary" size="40px" />
                            </div>
                        ) : (
                            <div className={classes.mainContainer}>
                                {banners.map((banner, index) => (
                                    <div key={index} className={classes.bannerContainer}>
                                        <label style={{ fontSize: "1.25rem", color: "#555" }}>
                                            Banner {banner.banner_position}
                                        </label>
                                        <button
                                            className={classes.bannerButton}
                                            onClick={() => history.push({
                                                pathname: "/adicionar-banners",
                                                state: { banner, type: "primary" }
                                            })}
                                        >
                                            {banner.banner_name || "Adicionar banner"}
                                            <img src={ArrowRight} alt="arrow" />
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
                <CustomAlert
                    type={alertType}
                    alertText={
                        alertType === "success"
                            ? ""
                            : "Erro ao carregar banners!"
                    }
                    show={showAlertOk || showAlertError}
                    close={() => closeAlerts()}
                />
            </div>
        </>
    )
}